import React from "react";

import { faSearch } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IonInput } from "@ionic/react";

const Search: React.FC<any> = (props) => {
  const { placeholder, ...fieldProps } = props;

  return (
    <IonInput placeholder={props.attr?.placeholder ? props.attr?.placeholder : placeholder} type="text" {...fieldProps}>
      <FontAwesomeIcon icon={faSearch} />
      {props.children}
    </IonInput>
  );
};

export default Search;
